import { render, staticRenderFns } from "./Wp_pdd_order_list.vue?vue&type=template&id=13eb5479&scoped=true&"
import script from "./Wp_pdd_order_list.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_order_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eb5479",
  null
  
)

export default component.exports